/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamRevisionGridQueryResponse,
  GetApiV1ExamRevisionGridQueryParams,
  GetApiV1ExamRevisionGrid401,
  GetApiV1ExamRevisionGrid500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionGrid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamRevisionGrid } from "../../clients/examRevisionController/getApiV1ExamRevisionGrid.ts";

export const getApiV1ExamRevisionGridQueryKey = (
  params?: GetApiV1ExamRevisionGridQueryParams,
) =>
  [{ url: "/api/v1/exam/revision/grid" }, ...(params ? [params] : [])] as const;

export type GetApiV1ExamRevisionGridQueryKey = ReturnType<
  typeof getApiV1ExamRevisionGridQueryKey
>;

export function getApiV1ExamRevisionGridQueryOptions(
  params?: GetApiV1ExamRevisionGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamRevisionGridQueryKey(params);
  return queryOptions<
    GetApiV1ExamRevisionGridQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamRevisionGrid401 | GetApiV1ExamRevisionGrid500
    >,
    GetApiV1ExamRevisionGridQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamRevisionGrid(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de provas geradas por bot, ordenadas pela data de início da aula de forma decrescente. Suporta filtros opcionais por disciplina, turma de aluno e data exata de realização da aula. **(Requer Authorization para autenticação)**
 * @summary Listar provas geradas por IA no grid (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/grid}
 */
export function useGetApiV1ExamRevisionGrid<
  TData = GetApiV1ExamRevisionGridQueryResponse,
  TQueryData = GetApiV1ExamRevisionGridQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamRevisionGridQueryKey,
>(
  params?: GetApiV1ExamRevisionGridQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamRevisionGridQueryResponse,
        ResponseErrorConfig<
          GetApiV1ExamRevisionGrid401 | GetApiV1ExamRevisionGrid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamRevisionGridQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamRevisionGridQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1ExamRevisionGrid401 | GetApiV1ExamRevisionGrid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
